import type React from 'react';

export interface FieldValidation {
  validateInput: (value: string) => boolean;
  errorMessage: (value: string) => React.ReactNode;
}

export interface FieldConfig {
  validation: FieldValidation;
  placeholder: string;
}

export const validateRegex: FieldValidation = {
  validateInput: (value: string) => {
    try {
      new RegExp(value);
      return true;
    } catch {
      return false;
    }
  },
  errorMessage: (value: string) => {
    try {
      new RegExp(value);
      return '';
    } catch (e) {
      return e instanceof SyntaxError ? e.message : 'Invalid regex';
    }
  },
};
